import { render, staticRenderFns } from "./File-input.vue?vue&type=template&id=2440780d"
import script from "./File-input.vue?vue&type=script&lang=js"
export * from "./File-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports